import { createStore } from 'jotai'
import { createContext, useContext } from 'react'

export type AssetHubStore = ReturnType<typeof createStore>

export const AssetHubStoreContext = createContext<AssetHubStore | null>(null)

export function createAssetHubStore(): AssetHubStore {
	return createStore()
}

export function useAssetHubStore(): AssetHubStore {
	const store = useContext(AssetHubStoreContext)
	if (!store) {
		throw new Error('useAssetHubStore must be used within an AssetHubManager')
	}
	return store
}
